import React, { FC, useCallback, useEffect, useState } from 'react';

import iconRestaurantMarker from '@assets/JETRestaurantMarker.svg';
import { OverlayView } from '@react-google-maps/api';
import { useKeycloakUserState } from '@src/shared/context/keycloak-user';
import { Typography } from '@material-ui/core';
import JetFontIcon, { JET_FONTICON_ALIASES } from '@src/shared/components/JetFontIcon';
import useStyles from './styles';
interface IRestaurantMarkerProps {
  lat: number;
  lng: number;
}

const RestaurantMarker: FC<IRestaurantMarkerProps> = ({ lat, lng }) => {
  const classes = useStyles();
  const { restaurant } = useKeycloakUserState();
  const [showDetail, setShowDetail] = useState<Boolean>(false)
  const offsetHandler = useCallback(
    (_, offsetHeight) => ({
      x: -11,
      y: 11 - offsetHeight,
    }),
    []
  );
  
  useEffect(()=> {
    if (showDetail === true) {
      setTimeout(()=> {
        setShowDetail(false)
      },20000)
    }
  },[showDetail])

  return (
    <OverlayView
      position={{ lat, lng }}
      getPixelPositionOffset={offsetHandler}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <>
       {showDetail && <div className={classes.restaurantName}>
        <Typography variant={'caption'} align='center' className={`caption_bold`}>
         <JetFontIcon iconname={JET_FONTICON_ALIASES.CURRY}></JetFontIcon> {restaurant?.name}
          </Typography>
        </div>}
        <img onClick={()=> {
          if (!showDetail) {
            setShowDetail(true)
          }
        }} src={iconRestaurantMarker} />
      </>
    </OverlayView>
  );
};

export default RestaurantMarker;
